var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"validation-messages mt-1 d-flex flex-row text-danger"},_vm._l((_vm.messages),function(msg){return _c('span',{key:msg.message},[_vm._v(" "+_vm._s(msg.message)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }